<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="회사명(필수)"
      :options="[
        { type: 'text', label: '점검자', value: '점검자' },
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" :title="$t('예방 점검표')" contentBefore="•" v-model="form.inspectList" class="mt-28px" />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t("결재란") }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import { required } from "vuelidate/lib/validators";
import Print from "./Print.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        점검자: { required },
        점검일: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "안전·보건 합동점검표",
      form: {
        stdInfo: {},

        fileList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        inspectList: [
          {
            content:
              "<span class='font-normal'>작업 중 땀을 많이 흘리게 되는 장소에 소금과 깨끗한 음료수(생수 등) 등을 충분히 갖추어 두었는지</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제571조)</span>",
            isChecked: "",
            title: "물",
          },
          {
            content: "<span class='font-normal'>폭염작업 시 냉방 또는 통풍 등을 위한 적절한 온·습도 조절장치를 설치 · 가동하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제560조)</span>",
            isChecked: "",
            title: "냉방장치",
          },
          {
            content: "<span class='font-normal'>작업시간대의 조정 등 폭염 노출을 줄일 수 있는 조치를 하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제560조)</span>",
            isChecked: "",
            title: "냉방장치",
          },
          {
            content: "<span class='font-normal'>체감온도 31도 이상 폭염작업 시 적절한 휴식을 주기적으로 부여하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제560조)</span>",
            isChecked: "",
            title: "휴식",
          },
          {
            content: "<span class='font-normal'>체감온도 33도 이상 폭염작업 시 매 2시간 마다 20분 이상의 휴식을 부여하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제560조)</span>",
            isChecked: "",
            title: "휴식",
          },
          {
            content: "<span class='font-normal'>폭염 노출 옥외 장소에서 작업 시 그늘진 장소를 제공하는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제567조)</span>",
            isChecked: "",
            title: "휴식",
          },
          {
            content: "<span class='font-normal'>휴식시간에 이용할 수 있는 휴게시설을 설치하고 설치 관리 기준을 준수하는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(산업안전보건법 제128조의2)</span>",
            isChecked: "",
            title: "휴식",
          },
          {
            content:
              "<span class='font-normal'>체감온도 33도 이상 폭염작업 시 휴식을 부여하기 매우 곤란한 경우 <br>→ 개인용 냉방 또는 통풍장치 지급·가동 또는 개인용 보냉장구 지급·가동 여부</span><br>" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제560조)</span>",
            isChecked: "",
            title: "보냉장구",
          },
          {
            content: "<span class='font-normal'>폭염작업 근로자의 온열질환자(의심자) 발생 시 즉시 119 신고</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제562조)</span>",
            isChecked: "",
            title: "응급조치",
          },
        ],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검자"].required) return "점검자를 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검일"].required) return "점검일을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
